import { render, staticRenderFns } from "./UserRequestHistories.vue?vue&type=template&id=23cb91b0&scoped=true"
import script from "./UserRequestHistories.vue?vue&type=script&lang=js"
export * from "./UserRequestHistories.vue?vue&type=script&lang=js"
import style0 from "./UserRequestHistories.vue?vue&type=style&index=0&id=23cb91b0&prod&lang=scss&scoped=true"
import style1 from "./UserRequestHistories.vue?vue&type=style&index=1&id=23cb91b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb91b0",
  null
  
)

export default component.exports